import React from "react";
import { observer } from "mobx-react";

import { useAppStore } from "../../../providers/AppStoreProvider";

export const FormStep = observer(({ step = 1, setStep }) => {
  const store = useAppStore();

  const changeStepHanlder = (toStep) => {
    if (toStep > 1 && !store.lessonModal.entityId) return;

    setStep(toStep);
  };

  return (
    <div className="form-step mb-5">
      <div className="step-indicator">
        <div
          className="step-indicator-inner"
          style={{ width: `calc(${(100 / 6) * (2 * step - 1)}%)` }}
        />
      </div>

      <div className="steps">
        {["Thông tin cơ bản", "Nội dung khoá học", "Tài nguyên"].map((stepText, index) => (
          <div className="step" key={`step-${index}`}>
            <div
              role="button"
              className="step-num"
              data-active={step >= index + 1}
              onClick={changeStepHanlder.bind(null, index + 1)}
            >
              <span style={{ zIndex: 10 }}>{index + 1}</span>
            </div>
            <div
              className="active-border"
              style={{ display: step === index + 1 ? "block" : "none" }}
            />
            <div className="step-text" data-active={step === index + 1}>
              {stepText}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});
